import React, { useState, useEffect } from "react"
import Flink from '~/components/shared/flink'
import { useTheme } from '~/contexts/ThemeContext'
import { usePdp } from '~/contexts/PdpContext'
import { imgSize, altText, notBlank, jnstyls } from '~/utils/helpers'

import FavProd from '~/components/shared/fav-prod'
import ImgStrip from '~/components/pdp/img-strip'
import Title from '~/components/pdp/title'
import Colorways from '~/components/pdp/colorways'
import InfoAccord from '~/components/pdp/info-accord'
import Sizes from '~/components/shared/sizes'
import Hem from '~/components/pdp/hem'
import Cta from '~/components/pdp/cta'
import Bis from '~/components/pdp/bis'
import ShipPickup from '~/components/pdp/pickup'

import * as styles from "~/styles/testing/blog-pdp.module.scss"


const BlogPdpDetails = ({setTeston, setData}) => {
  const { 
    product, showCta, showBis, wasRedirect, showAfterp, showShipInfo,  
    recProds, showHemInfo, setShowHemInfo, shipCheck, showStoresPanel,
    showStickyCta, setShowStickyCta, prodInv, isSHM
  } = usePdp()
  const { is_gift, is_single, final_sale, media, isQuick } = product
  const { pdpVariant, isMobile, customer } = useTheme()

  const show_newship = () => {
    if (!prodInv) return false
    const wh_combo = prodInv && (prodInv?.inventory?.DW?.length > 0 || !!prodInv?.inventory['BL - Ecommerce']?.length > 0)
    const ship_avail = !isSHM ? shipCheck?.ship : wh_combo
    return (!is_gift && showCta && (ship_avail || shipCheck?.pickup))
  }
 
  return (
    <div className={styles.bpdp}>
      <div className={styles.head}>
        <div className={styles.gall}>
          {(media && media.length > 0) && (
            <div className={jnstyls([styles.images, styles.strip_wr])}>
              <ImgStrip 
                media={media} 
                handle={product.handle} 
                title={product.title} 
              />
            </div>
          )}
        </div>

        <div className={styles.info}>
          <Title />
          <br/>
          <br/>
          {product.product_line.short_description}
        </div>
      </div>

      {product?.color?.handle && (
        <Colorways />
      )}

      {(product.variants && product.variants.length > 0) && (
        <Sizes />
      )}

      {product.hem && (
        <Hem />
      )}

      {(prodInv && showCta) && (
        <Cta />
      )}
      {(prodInv && showBis) && (
        <Bis />
      )}

      {(!showBis && show_newship()) && (
        <ShipPickup />
      )}
      <br/>
      <button onClick={(e)=> {setTeston(false); setData(null)}}>
        Nah....close this thing
      </button>
    </div>
  )
}


export default BlogPdpDetails






